
import * as angular from "angular";
import { IPlot } from "@interfaces/IPlot";
import { IVehicle } from "@interfaces/IVehicle";
import { VehicleService } from "@services/vehicle.service";
import "./nearestVehicles.scss";

interface IComponentBindings {
    plot: IPlot;
    latLng: google.maps.LatLng;
    onVehicleClicked: (args: { vehicle: IVehicle }) => void;
}

interface IVehicleDistance {
    vehicle: IVehicle;
    distance: number;
    roundedDistance: number;
}

class Controller implements angular.IComponentController, IComponentBindings {

    plot: IPlot;
    latLng: google.maps.LatLng;
    onVehicleClicked: (args: { vehicle: IVehicle }) => void;

    nearestVehicles: IVehicleDistance[] = [];
    loading = false;

    static $inject = ["vehicleService"];

    constructor(private readonly vehicleService: VehicleService) {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {

        if (this.plot) {
            this.latLng = new google.maps.LatLng(this.plot.Latitude, this.plot.Longitude);
        }

        if (this.latLng) {
            this.updateNearestVehicles();
        }
    }

    vehicleClicked(vehicle: IVehicle) {
        if (this.onVehicleClicked) {
            this.onVehicleClicked({ vehicle: vehicle });
        }
    }

    // -----------------------

    private updateNearestVehicles() {

        this.loading = this.nearestVehicles.length == 0;

        this.vehicleService.getVehicles({ includeLatestPlots: true, includePeripheralMappings: true })
            .then(vehicles => {
                performance.mark("nearestVehicles");
                //var vehicleLatLng = this.latLng;
                this.nearestVehicles = [];

                // Create distances
                for (var i = 0; i < vehicles.length; i++) {
                    const vehicle = vehicles[i];

                    if (!vehicle.Plot) {
                        continue;
                    }

                    var center = new google.maps.LatLng(vehicle.Plot.Latitude, vehicle.Plot.Longitude);
                    var dist = google.maps.geometry.spherical.computeDistanceBetween(this.latLng, center);

                    this.nearestVehicles.push({
                        vehicle: vehicle,
                        distance: dist,
                        roundedDistance: Math.round(dist / 1000) // convert from metres to km
                    });
                }

                this.nearestVehicles.sort((a, b) => {
                    return a.distance > b.distance ? 1 : -1;
                });

                performance.measure("nearestGeofences");

                this.nearestVehicles = this.nearestVehicles.slice(0, 5);
            })
            .finally(() => {
                this.loading = false;
            });
    }
}

export class NearestVehiclesComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            plot: "<",
            latLng: "<",
            onVehicleClicked: "&"
        };

        this.controller = Controller;
        this.template = require("./nearestVehicles.html");
    }
}
